<template>
  <div class='domain-node-properties'>
    <div class='domain-node-properties__header'>
      <div>
        <v-icon>language</v-icon>
      </div>
      <div class='domain-node-properties__header__title'>
        <div class='domain-node-properties__header__title__name'>
          {{name}}
        </div>
        <div class='domain-node-properties__header__title__type'>
          {{$t(`ctc.properties.type.${data.type.toLowerCase()}`)}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DomainNodeProperties',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  computed: {
    name() {
      return this.data.name;
    },
  },
};
</script>
<style scoped lang='scss'>
@import '~@/assets/styles/design-system';
.domain-node-properties{
  display: flex;
  flex-direction: column;
  margin-top: rem(15);
  &__header{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: rem(10);
    &__title{
      display: flex;
      flex-direction: column;
      margin-left: rem(15);
      &__name{
        color: var(--text-primary);
        font-family: $font-family-regular;
        font-size: rem(16);
        font-weight: bold;
        letter-spacing: 0;
        line-height: rem(17);
      };
      &__type{
        color: var(--text-tertiary);
        font-family: $font-family-regular;
        font-size: rem(10);
        letter-spacing: 1.1px;
        line-height: rem(15);
        margin-top: rem(5);
        text-transform: uppercase;
      };
    };
  }
}
</style>
